import { render } from "./ShowNatalPlanets.vue?vue&type=template&id=419d1b9c&scoped=true"
import script from "./ShowNatalPlanets.vue?vue&type=script&lang=js"
export * from "./ShowNatalPlanets.vue?vue&type=script&lang=js"

import "./ShowNatalPlanets.vue?vue&type=style&index=0&id=419d1b9c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2784445594/src/vedicastrochart-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419d1b9c"]])

export default __exports__